import apiClient from "./apiClient";

/**
 * Fetch Company-Wide Call Summary Report
 */
export const getCallSummaryReport = async (companyCode, period, from, to) => {
  try {
    const effectivePeriod = period || "today";
    const params = {};
    if (companyCode) params.companyCode = companyCode;
    if (effectivePeriod === "custom" && from) {
      params.from = from;
      if (to) params.to = to;
    } else {
      params.period = effectivePeriod;
    }

    const res = await apiClient.get("/api/call-logs/summary", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("getCallSummaryReport error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Fetch Employee Call Statistics Breakdown Report
 */
export const getEmployeeCallReport = async (companyCode, period, from, to, filters) => {
  try {
    const effectivePeriod = period || "today";
    const safeFilters = filters || {};
    const params = {};
    if (companyCode) params.companyCode = companyCode;
    if (effectivePeriod === "custom" && from) {
      params.from = from;
      if (to) params.to = to;
    } else {
      params.period = effectivePeriod;
    }
    if (safeFilters.callType && safeFilters.callType !== "Select" && safeFilters.callType !== "all") {
      params.callType = safeFilters.callType;
    }
    if (safeFilters.duration && safeFilters.duration !== "Select" && safeFilters.duration !== "all") {
      params.duration = safeFilters.duration;
    }
    if (safeFilters.callTime && safeFilters.callTime !== "Select" && safeFilters.callTime !== "all") {
      params.callTime = safeFilters.callTime;
    }

    const res = await apiClient.get("/api/call-logs/employees", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("getEmployeeCallReport error:", error);
    return { success: false, message: error.message, employees: [] };
  }
};

/**
 * Fetch Detailed Call History Log for an Employee
 */
export const getCallDetailsReport = async (companyCode, employeeId, date) => {
  try {
    const params = {};
    if (companyCode) params.companyCode = companyCode;
    if (employeeId) params.employeeId = employeeId;
    if (date) params.date = date;

    const res = await apiClient.get("/api/call-logs/details", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("getCallDetailsReport error:", error);
    return { success: false, message: error.message, calls: [] };
  }
};
